import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 24.965px;
  height: 24.965px;
  margin-right: 0.5rem;
`;

const OSWindowsIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 3.438l10.231-1.41v9.886H0zm0 18.089l10.231 1.41v-9.764H0zm11.357 1.56l13.608 1.878V13.173H11.357zm0-21.209v10.036h13.608V0L11.357 1.878z"
        fill="#4694ce"
      />
    </Svg>
  );
};

export default OSWindowsIcon;
